import axiosInstance from '../config/axios';

/**
 * خدمة للتعامل مع أجهزة المستخدمين
 */
export const deviceService = {
  /**
   * الحصول على قائمة المستخدمين مع أجهزتهم
   * @returns {Promise<Array>} قائمة المستخدمين
   */
  async getAllUsers() {
    try {
      const response = await axiosInstance.get('/api/admin/devices');
      return response.data;
    } catch (error) {
      console.error('Error fetching users with devices:', error);
      throw error;
    }
  },

  /**
   * الحصول على أجهزة مستخدم معين
   * @param {number} userId معرف المستخدم
   * @returns {Promise<Object>} بيانات المستخدم وأجهزته
   */
  async getUserDevices(userId) {
    try {
      const response = await axiosInstance.get(`/api/admin/devices/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user devices:', error);
      throw error;
    }
  },

  /**
   * بحث عن مستخدمين مع أجهزتهم (مبوب)
   * @param {Object} params معايير البحث (search, per_page)
   * @returns {Promise<Object>} بيانات وصفحات
   */
  async searchUsers(params = {}) {
    try {
      const response = await axiosInstance.get('/api/admin/devices/search', { params });
      return response.data;
    } catch (error) {
      console.error('Error searching users with devices:', error);
      throw error;
    }
  },

  /**
   * إحصائيات الأجهزة
   * @returns {Promise<Object>} إحصائيات (total_users, total_devices, avg_devices_per_user)
   */
  async getDeviceStats() {
    try {
      const response = await axiosInstance.get('/api/admin/devices/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching device stats:', error);
      throw error;
    }
  },

  /**
   * حذف جهاز
   * @param {number} userId معرف المستخدم
   * @param {number} deviceId معرف الجهاز
   * @returns {Promise<Object>} رسالة نجاح
   */
  async deleteDevice(userId, deviceId) {
    try {
      const response = await axiosInstance.delete(`/api/admin/devices/${userId}/${deviceId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting device:', error);
      throw error;
    }
  }
};
